<template>
  <div class="user_category">
    <div class="table_card mb-5">
      <div class="table_card__head">
        <p class="table_card__head--title">
          Asignar Usuario al Inmueble
        </p>
      </div>
      <div class="table_card__body">
        <v-layout row wrap>
          <v-flex xs12 lg6 class="pr-3">
            <label
              class="table_card__info--label"
              :class="{ 'custom_input__title--colapsed': sublocation && sublocation.attributes && sublocation.attributes.name != '' }"
            >
              Nombre Inmueble:
            </label>
            <input
              class="faccess_input"
              :class="{ 'custom_input__inputs--open': sublocation && sublocation.attributes && sublocation.attributes.name != '' }"
              type="text"
              v-model="sublocation.attributes.name"
            />
          </v-flex>
          <v-flex xs12 lg6 class="pr-3">
            <label
              class="table_card__info--label"
              :class="{ 'custom_input__title--colapsed': sublocation.attributes.name != '' }"
            >
              Usuario Asignado:
            </label>
            <input
              class="faccess_input"
              :disabled="true"
              :class="{ 'custom_input__inputs--open': user_name != '' }"
              type="text"
              v-model="user_name"
            />
          </v-flex>
          <button
            class="faccess_button"
            @click="updateSublocation()"
            :disabled="sublocation.attributes.user_id == null"
          >
            Guardar
          </button>
        </v-layout>
      </div>
    </div>
    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg6 class="head_contain">
            <p class="table_card__head--title">
              Usuarios Disponibles
            </p>
          </v-flex>
          <v-flex xs12 lg6 class="filter_options">
            <v-flex class="right">
              <input
                type="text"
                placeholder="Buscar"
                class="input_solid"
                v-model="options_table.search"
              >
              <img
                src="@/assets/img/icons/search-icon.svg"
                class="button_search"
              >
            </v-flex>
            <div
              class="buttom_reload"
                @click="getUsers()"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div>

        <v-data-table
          v-model="users"
          :headers="options_table.headers_table"
          :items="filteredUsers"
          :search="options_table.search"
          :pagination.sync="options_table.pagination"
          hide-actions
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th>
                <!-- <v-checkbox
                  :input-value="props.all"
                  :indeterminate="props.indeterminate"
                  color="#1476FB"
                  hide-details
                  @click.native="toggleAll"
                ></v-checkbox> -->
              </th>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column sortable', options_table.pagination.descending ? 'desc' : 'asc', header.value === options_table.pagination.sortBy ? 'active' : '']"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr>
              <td>
                <v-checkbox
                  :input-value="props.item.id == selected_user_id"
                  color="#1476FB"
                  hide-details
                  @change="selectUser(props.item.id)"
                ></v-checkbox>
              </td>
              <td class="text-xs-center" width="180px">{{ props.item.rut }}</td>
              <td class="text-xs-center">{{ props.item.name }}</td>
            </tr>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination :value ="page" :length="pages" @input="changePage"></v-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["userCategoryId"],
  data() {
    return {
      sublocation_id: '',
      user_name: "",
      sublocation: {
        attributes: {
          name: ''
        }
      },
      selected_user_id: '',
      search: '',
      options_table:{
        pagination: {
          sortBy: 'name',
          rowsPerPage: 20
        },
        headers_table:[
          {
            text: 'N° Documento',
            align: 'center',
            value: 'rut'
          },
          {
            text: 'Nombre Usuario',
            align: 'center',
            value: 'name'
          }
        ],
        filters: {
          rut: [],
          name: [],
        },
      },
      users: [],
      users_for_select:[],
      right_now: true,
      page: 1,
      pages: 1
    };
  },
  computed: {
    filteredUsers() {
      return this.users_for_select.filter(d => {
        return Object.keys(this.options_table.filters).every(f => {
          return this.options_table.filters[f].length < 1 || this.options_table.filters[f].includes(d[f])
        })
      })
    },
  },
  watch: {
  },
  methods: {
    changeSort (column) {
      if (this.options_table.pagination.sortBy === column) {
        this.options_table.pagination.descending = !this.options_table.pagination.descending
      } else {
        this.options_table.pagination.sortBy = column
        this.options_table.pagination.descending = false
      }
    },
    getUsers(){
      let params = { page: this.page }
      const data = { company: {id: this.getCompany().id}, sublocation_id: this.sublocation_id }
      try {
        this.$http.post('app/sublocations/get_active_users',{data:this.encrypt(data).toString()},{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
           params
        })
        .then(function(response){
          this.users_for_select = response.body.data
          this.user_name = response.body.meta.assigned_user_name
          this.pages = response.body.meta.pages
          if(this.sublocation.attributes.user_id != null && this.sublocation.attributes.user_id != ''){
            this.selectUser(this.sublocation.attributes.user_id)
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    getSublocation(){
      this.sublocation_id = this.$route.params.sublocation_id
      try {
        this.$http.get('sublocations/'+ this.sublocation_id,{
          headers:{
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer ' + this.getUserToken()
          }
        })
        .then(function(response){
          this.sublocation = response.body.data
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    updateSublocation(){
      console.log('---------------as--------------------------------------')
      let data = this.sublocation
      try {
        this.$http.post('app/sublocations/assign_user_to_sublocation',{ data: this.encrypt(data).toString()},
        {
          headers:{
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()
          }
        })
        .then(function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          this.updateAlertMessage(response.body.ans);
          this.updateIsInAlert(true);
          console.log('---------------as--------------------------------------')
          this.$router.push({name: 'payments_status'})
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    selectUser(user_id) {
      if (this.selected_user_id != user_id){
        this.selected_user_id = user_id
        this.sublocation.attributes.user_id = user_id
        this.users_for_select.filter(user => {
          if (user.id == user_id){
            this.user_name = user.name
          }
        });
      }
    },
    changePage (page){
      this.page = page
      this.getUsers();
    }
  },
  mounted() {
    this.getSublocation();
    this.getUsers();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/users/payment_status/SublocationUser.vue